/**
 * Returns the sanitized version of a recording filename to be downloaded. Replacing invalid characters with a separator value.
 *
 * @param {String} key - value to be sanitized
 * @param {String} separator - value used to replace invalid characters
 * @returns {String}
 */

export default function sanitize(key, separator = '-') {
  return key.replace(/[/\\?%*:;|"<>,~™]/g, separator);
}
